import { TextbookDrawerService } from '../textbook-drawer.service';

export abstract class Tool {
  /**
   * Current size of tool
   */
  protected size!: number;
  /**
   * Current color of tool
   */
  protected color!: string;
  /**
   * Used to block handlers.
   */
  protected isLocked = false;

  constructor(
    /**
     * Context of canvas which presents the current state of drawing (image).
     */
    protected mainCtx: CanvasRenderingContext2D,
    /**
     * Context of canvas used to animations that shouldn't update main image.
     */
    protected animCtx: CanvasRenderingContext2D,
    /**
     * Should be called after each completed step of drawing.
     */
    protected updateState: () => void
  ) {
    this.mainCtx.lineJoin = this.animCtx.lineJoin = 'round';
    this.mainCtx.lineCap = this.animCtx.lineCap = 'round';
    this.mainCtx.globalCompositeOperation = this.animCtx.globalCompositeOperation = 'source-over';
  }

  /**
   * Allow to lock entire tool, to not respond for events.
   */
  setLocked(isLocked: boolean): void {
    this.isLocked = isLocked;
  }

  /**
   * Allow to set color of tool. Tools can interpret this in a different way.
   */
  setSize(size: number): void {
    this.size = size;
  }

  /**
   * Allow to set size of tool. Tools can interpret this in a different way.
   */
  setColor(color: string): void {
    this.color = color;
  }

  /**
   * Logic of new tool goes here.
   */
  onMouseDown(e: MouseEvent | TouchEvent): void {}

  /**
   * Logic of new tool goes here.
   */
  onMouseMove(e: MouseEvent | TouchEvent): void {}

  /**
   * Logic of new tool goes here.
   */
  onMouseUp(e: MouseEvent | TouchEvent): void {}

  /**
   * Logic of new tool goes here. Default it fallbacks to `this.onMouseDown`.
   */
  onTouchStart(e: MouseEvent | TouchEvent): void {
    this.onMouseDown(e);
  }

  /**
   * Logic of new tool goes here. Default it fallbacks to `this.onMouseMove`.
   */
  onTouchMove(e: MouseEvent | TouchEvent): void {
    this.onMouseMove(e);
  }

  /**
   * Logic of new tool goes here. Default it fallbacks to `this.onMouseUp`.
   */
  onTouchEnd(e: MouseEvent | TouchEvent): void {
    this.onMouseUp(e);
  }

  /**
   * This method is called when tool is changed (destroyed).
   *
   * Place here any logic like removing listeners, clearing intervals or unsubscribing.
   */
  teardown(): void {}

  /**
   * Update ctx properties to the current size and color.
   */
  protected updateCtxStyle(ctx: CanvasRenderingContext2D): void {
    ctx.strokeStyle = this.color;
    ctx.lineWidth = this.size;
  }

  /**
   * Clears entire content in passed context.
   */
  protected clearCtx(ctx: CanvasRenderingContext2D): void {
    const { width, height } = ctx.canvas;
    ctx.clearRect(0, 0, width, height);
  }

  /**
   * Returns current position of cursor in canvas context origin.
   */
  protected getMousePosition(e: MouseEvent | TouchEvent): { x: number; y: number } {
    const { pageX, pageY } = e instanceof MouseEvent ? e : e.changedTouches[0];
    const { left, top } = this.animCtx.canvas.getBoundingClientRect();
    const { width, height, offsetWidth, offsetHeight } = this.mainCtx.canvas;

    return {
      x: (pageX - left) * (width / offsetWidth),
      y: (pageY - top) * (height / offsetHeight),
    };
  }
}
